import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getFieldsByType, getControlIsRenderable } from 'utilities'
import { DumbField, getValidityClass } from '../Field'
import { TextInput, Select } from './Form'
import { getStateOptions, getCountryOptions, filteredStateOptions } from '../selectOptions'
import Portal from 'components/Portal/Portal'
import { Modal } from '../../Modal/Modal'
import AddressSelector from './AddressSelector'
import ReactTooltip from 'react-tooltip'
import DocumentCloneIcon from '@tecuity/sos-icons/react/document-clone'
import { MASK, VALIDATE } from '../validate'
import { setFieldAttributes } from '../WizardActions'
import { isCountryUSA } from '../../../Utilities/Utilities'
import { setSuccessToast } from '../../../actions'
import store from '../../../store'

export class AddressBlock extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
      isValid: props.isValid,
      showCopyAddressError: false,
      copyAddressErrorMessage: '',
    }
  }
  componentDidMount = () => {
    if (this.props.isFirst) {
      // DN - no longer autofocusing on first element because of ADA compliance issues
      //this.focus()
    }
  }
  componentDidUpdate = (prevProps) => {
    if (this.props.isValid !== null && prevProps.isValid !== this.props.isValid) {
      this.setState({ isValid: this.props.isValid })
    }
  }
  setFieldValue = (value, e) => {
    const caretPosition =
      (e.target.name == 'POSTAL_CODE' || e.target.name == 'PostalCode') &&
      e.target.selectionEnd == 6
        ? e.target.selectionEnd + 1
        : e.target.selectionEnd
    var val = { ...this.props.value }
    val[e.target.name] = value
    this.props.onChange(val, { target: { name: this.props.name, value: val } })
    this.setState({ currentCursor: caretPosition }, () => {
      e.target.selectionEnd = this.state.currentCursor
      e.target.selectionStart = this.state.currentCursor
    })
  }
  handleFieldBlur = (e) => {
    //Only validate with AMS if it leaves the address block
    if (
      this.props.validateAdvance &&
      (!e || !document.getElementById(this.props.fieldId).contains(e.relatedTarget))
    ) {     
      this.props.onBlur(this.props.value, 'onAdvance', {}, {})
      if (
        !this.props.isNewFormat &&
        this.props.value.ADDR1 &&
        this.props.value.CITY &&
        this.props.value.STATE &&
        this.props.value.POSTAL_CODE
      ) {
        this.populateAddressFromAMS()
      } else if (
        this.props.isNewFormat &&
        this.props.value.AddressLine1 &&
        this.props.value.City &&
        this.props.value.StateOrProvince &&
        this.props.value.PostalCode
      ) {
        this.populateAddressFromAMS()
      } else {
        this.populateAddressFromAMS()
      }
    }
  }
  toggleAddressSelect = () => {
    this.setState((state) => ({
      modalOpen: !state.modalOpen,
      showCopyAddressError: false,
      copyAddressErrorMessage: '',
    }))
  }
  copyAddress = (selectedAddress) => {
    const {
      value,
      disableCountry,
      showCountry,
      disableState,
      isNewFormat = false,
      defaultState,
    } = this.props
    if ((disableCountry || !showCountry) && selectedAddress.COUNTRY !== value.COUNTRY) {
      //This messes with rules. Do not copy address
      this.setState({
        showCopyAddressError: true,
        copyAddressErrorMessage: 'Verify country is ' + value.COUNTRY + ' and try again.',
      })
      return
    }
    this.modal.closeModal()
    let newAddress = { ...selectedAddress }
    if (disableState) {
      newAddress = {
        ...newAddress,
        [isNewFormat ? 'StateOrProvince' : 'STATE']: defaultState,
      }
    }
    this.props.onChange(newAddress, {})
    store.dispatch(setSuccessToast('Successfully copied address'))
  }
  focus = () => {
    this.addr1.focus()
  }
  handleStateBlur = () => {
    if (
      this.props.isNewFormat &&
      this.props.autoPopulateFromAMS &&
      this.props.value.StateOrProvince &&
      this.props.value.City &&
      !this.props.PostalCode
    ) {
      this.populateAddressFromAMS()
    } else if (
      this.props.autoPopulateFromAMS &&
      this.props.value.STATE &&
      this.props.value.CITY &&
      !this.props.POSTAL_CODE
    ) {
      this.populateAddressFromAMS()
    }
  }
  handleZipBlur = () => {
    if (
      this.props.isNewFormat &&
      this.props.autoPopulateFromAMS &&
      this.props.value.PostalCode &&
      (!this.props.value.StateOrProvince || !this.props.value.City)
    ) {
      this.populateAddressFromAMS()
    } else if (
      this.props.autoPopulateFromAMS &&
      this.props.value.POSTAL_CODE &&
      (!this.props.value.STATE || !this.props.value.CITY)
    ) {
      this.populateAddressFromAMS()
    }
  }
  populateAddressFromAMS = () => {
    const validAddressBusinessRule = this.props.businessRules.find(
      (rule) => rule.fn == 'addressIsValid'
    )
    if(validAddressBusinessRule){
      if (this.props.isNewFormat) {
        VALIDATE.addressIsValidNew(this.props.value, this, {}, (isValid, error, address) => {
          const corrected = address.value || {}
          let newAddress = this.props.value
          let update = false
          if (
            /*!this.props.value.StateOrProvince && */ this.props.value.StateOrProvince !==
              corrected.StateOrProvince &&
            !this.props.disableState
          ) {
            newAddress = { ...newAddress, StateOrProvince: corrected.StateOrProvince }
            update = true
          }
          if (/*!this.props.value.City &&*/ this.props.value.City !== corrected.City) {
            newAddress = { ...newAddress, City: corrected.City }
            update = true
          }
          if (
            this.props.value.PostalCode !== corrected.PostalCode /*&& !this.props.value.PostalCode*/
          ) {
            newAddress = { ...newAddress, PostalCode: corrected.PostalCode }
            update = true
          }
          if (update) {
            this.props.onChange(newAddress)
          }
          this.setState({ isValid: isValid })
          this.props.setFieldAttributes({
            fieldId: this.props.fieldId,
            payload: { isValid: isValid },
          })
          address.infoMessage &&
            this.props.setFieldAttributes({
              fieldId: this.props.fieldId,
              payload: { infoMessage: address.infoMessage },
            })
          error &&
            this.props.setFieldAttributes({
              fieldId: this.props.fieldId,
              payload: {errorMessage: [error]},
            })
        })
      } else {
        VALIDATE.addressIsValid(this.props.value, this, {}, (isValid, error, address) => {
          const corrected = (address && address.value) || {}
          let newAddress = this.props.value
          let update = false
          if (
            /*!this.props.value.STATE && */ this.props.value.STATE !== corrected.STATE &&
            !this.props.disableState
          ) {
            newAddress = { ...newAddress, STATE: corrected.STATE }
            update = true
          }
          if (/*!this.props.value.CITY &&*/ this.props.value.CITY !== corrected.CITY) {
            newAddress = { ...newAddress, CITY: corrected.CITY }
            update = true
          }
          if (
            this.props.value.POSTAL_CODE !==
            corrected.POSTAL_CODE /*&& !this.props.value.POSTAL_CODE*/
          ) {
            newAddress = { ...newAddress, POSTAL_CODE: corrected.POSTAL_CODE }
            update = true
          }
          if (update) {
            this.props.onChange(newAddress)
          }
          if (isValid !== null) {
            this.setState({ isValid: isValid })
            this.props.setFieldAttributes({
              fieldId: this.props.fieldId,
              payload: { isValid: isValid },
            })
          }
          address && address.infoMessage &&
            this.props.setFieldAttributes({
              fieldId: this.props.fieldId,
              payload: { infoMessage: address.infoMessage },
            })
          error &&
            this.props.setFieldAttributes({
              fieldId: this.props.fieldId,
              payload: {errorMessage: [error]},
            })
        })
      }
    }
  }
  render() {
    const {
      fieldId,
      address1Label,
      required,
      value,
      disableCountry,
      showCounty,
      showCountry,
      showCityStateZip,
      hideThirdLine,
      disableState,
      disabled,
      hasAddresses,
      allowSelection,
      singleColSize,
      triColSizes = {},
      excludeCurrentState,
      // validateAdvance,
      classNames = {},
      isNewFormat = false,
    } = this.props
    const isValidClass = getValidityClass(this.state.isValid)
    const isForeign = !isCountryUSA(isNewFormat ? value.Country : value.COUNTRY)
    const label = this.props.label || 'Address'
    return (
      <div className="address-block" id={this.props.fieldId}>
        <div className="row">
          <div
            className={`${singleColSize ? singleColSize : 'col-sm-9 col-md-8 col-lg-7'} flex-col`}
          >
            <DumbField
              className="auto-width"
              type="text"
              required={required}
              parentType="addressBlock"
              label={address1Label ? address1Label : isForeign ? 'Address 1' : 'Address'}
              fieldId={`address1-${fieldId}`}
            >
              <div className="row-wrapper">
                <TextInput
                  fieldId={`address1-${fieldId}`}
                  onChange={this.setFieldValue}
                  onBlur={(value, e) => {
                    this.handleFieldBlur(e)
                  }}
                  autoComplete="address-line1"
                  name={isNewFormat ? 'AddressLine1' : 'ADDR1'}
                  value={isNewFormat ? value.AddressLine1 : value.ADDR1}
                  disabled={disabled}
                  required={true}
                  validityClass={isValidClass}
                  isValid={this.state.isValid}
                  ref={(addr1) => {
                    this.addr1 = addr1
                  }}
                  ariaLabel={`${label}: Address Line 1`}
                />
                {allowSelection !== false && (
                  <button
                    type="button"
                    className="btn btn-raised btn-primary copy-button"
                    disabled={!hasAddresses || disabled}
                    onClick={this.toggleAddressSelect}
                    data-tip="Copy from"
                    data-for={`copy-${fieldId}`}
                    aria-label="Copy address from"
                  >
                    <DocumentCloneIcon />
                  </button>
                )}
                <ReactTooltip effect="solid" place="top" id={`copy-${fieldId}`} />
              </div>
            </DumbField>
            <Portal isOpened={this.state.modalOpen}>
              <Modal
                title="Select an Address"
                closeModal={this.toggleAddressSelect}
                modalSize="small"
                closeButton
                autoHeight
                ref={(modal) => {
                  this.modal = modal
                }}
              >
                <AddressSelector onSelect={this.copyAddress} fieldId={fieldId}>
                  {this.state.showCopyAddressError && (
                    <div style={{ padding: '5px', color: 'hsl(345,100%,42%)' }}>
                      Failed to copy address: {this.state.copyAddressErrorMessage}
                    </div>
                  )}
                </AddressSelector>
              </Modal>
            </Portal>
          </div>
        </div>
        <div className="row">
          <div className={`${singleColSize ? singleColSize : 'col-sm-9 col-md-8 col-lg-7'}`}>
            <DumbField
              type="text"
              required={false}
              parentType="addressBlock"
              label={isForeign ? 'Address 2' : 'STE/APT/FL'}
              fieldId={`address2-${fieldId}`}
            >
              <TextInput
                onChange={this.setFieldValue}
                onBlur={(value, e) => {
                  this.handleFieldBlur(e)
                }}
                autoComplete="address-line2"
                name={isNewFormat ? 'AddressLine2' : 'ADDR2'}
                value={isNewFormat ? value.AddressLine2 : value.ADDR2}
                disabled={disabled}
                required={false}
                width="100%"
                validityClass={isValidClass}
                isValid={this.state.isValid}
                fieldId={`address2-${fieldId}`}
                ariaLabel={`${label}: ${isForeign ? 'Address line 2' : 'STE/APT/FL'}`}
              />
            </DumbField>
          </div>
        </div>
        {!hideThirdLine && (
          <div className="row">
            <div className={`${singleColSize ? singleColSize : 'col-sm-9 col-md-8 col-lg-7'}`}>
              <DumbField
                type="text"
                required={false}
                parentType="addressBlock"
                label={isForeign ? 'Address 3' : process.env.ADDRESS_ATTENTION_LABEL || 'Attention'}
                fieldId={`address3-${fieldId}`}
              >
                <TextInput
                  onChange={this.setFieldValue}
                  onBlur={(value, e) => {
                    this.handleFieldBlur(e)
                  }}
                  autoComplete="address-level4"
                  name={isNewFormat ? 'AddressLine3' : 'ADDR3'}
                  value={isNewFormat ? value.AddressLine3 : value.ADDR3}
                  disabled={disabled}
                  required={false}
                  width="100%"
                  validityClass={isValidClass}
                  isValid={this.state.isValid}
                  fieldId={`address3-${fieldId}`}
                  ariaLabel={`${label}: ${
                    isForeign ? 'Address line3' : process.env.ADDRESS_ATTENTION_LABEL || 'Attention'
                  }`}
                />
              </DumbField>
            </div>
          </div>
        )}
        {showCityStateZip && !isForeign ? (
          <div className="row">
            <div className={triColSizes.CITY ? triColSizes.CITY : 'col-sm-5 col-md-4 col-lg-3'}>
              <DumbField
                type="text"
                required={required}
                parentType="addressBlock"
                label="City"
                fieldId={`addr-city-${fieldId}`}
              >
                <TextInput
                  onChange={this.setFieldValue}
                  onBlur={(value, e) => {
                    this.handleFieldBlur(e)
                  }}
                  autoComplete="address-level2"
                  name={isNewFormat ? 'City' : 'CITY'}
                  value={isNewFormat ? value.City : value.CITY}
                  disabled={disabled}
                  required={true}
                  width="100%"
                  validityClass={isValidClass}
                  isValid={this.state.isValid}
                  fieldId={`addr-city-${fieldId}`}
                  ariaLabel={`${label}: City`}
                />
              </DumbField>
            </div>
            <div className={triColSizes.STATE ? triColSizes.STATE : 'col-sm-3 col-md-3 col-lg-2'}>
              <DumbField
                type="text"
                required={required}
                parentType="addressBlock"
                label="State"
                fieldId={`addr-state-${fieldId}`}
              >
                <Select
                  onChange={this.setFieldValue}
                  onBlur={(e) => {
                    this.handleFieldBlur(e)
                    this.handleStateBlur()
                  }}
                  options={[
                    { value: '', label: '' },
                    ...(excludeCurrentState ? filteredStateOptions() : getStateOptions()),
                  ]}
                  autoComplete="region"
                  name={isNewFormat ? 'StateOrProvince' : 'STATE'}
                  value={isNewFormat ? value.StateOrProvince : value.STATE}
                  required={true}
                  bubbleEvents={this.props.bubbleEvents}
                  width="100%"
                  validityClass={isValidClass}
                  isValid={this.state.isValid}
                  disabled={disabled === true ? true : disableState}
                  fieldId={`addr-state-${fieldId}`}
                  className={classNames.STATE}
                  ariaLabel={`${label}: State`}
                />
              </DumbField>
            </div>
            <div className={triColSizes.ZIP ? triColSizes.ZIP : 'col-sm-3 col-md-3 col-lg-2'}>
              <DumbField
                type="text"
                required={required}
                parentType="addressBlock"
                label="ZIP code"
                fieldId={`addr-zip-${fieldId}`}
              >
                <TextInput
                  onChange={(value, e) => this.setFieldValue(MASK.zipCode(value), e)}
                  onBlur={(value, e) => {
                    this.handleFieldBlur(e)
                    this.handleZipBlur()
                  }}
                  mask={[MASK.zipCode]}
                  name={isNewFormat ? 'PostalCode' : 'POSTAL_CODE'}
                  value={isNewFormat ? value.PostalCode : value.POSTAL_CODE}
                  autoComplete="postal-code"
                  disabled={disabled}
                  required={true}
                  width="100%"
                  validityClass={isValidClass}
                  isValid={this.state.isValid}
                  fieldId={`addr-zip-${fieldId}`}
                  ariaLabel={`${label}: ZIP code`}
                />
              </DumbField>
            </div>
          </div>
        ) : null}
        {showCounty ? (
          <div className="row">
            <div className="col-sm-7 col-md-6 col-lg-5">
              <DumbField
                type="text"
                required={required}
                parentType="addressBlock"
                label="County"
                fieldId={`addr-county-${fieldId}`}
              >
                <TextInput
                  onChange={this.setFieldValue}
                  onBlur={(value, e) => {
                    this.handleFieldBlur(e)
                  }}
                  name={isNewFormat ? 'County' : 'COUNTY'}
                  value={isNewFormat ? value.County : value.COUNTY}
                  disabled={disabled}
                  required={true}
                  width="100%"
                  validityClass={isValidClass}
                  isValid={this.state.isValid}
                  fieldId={`addr-county-${fieldId}`}
                  ariaLabel={`${label}: County`}
                />
              </DumbField>
            </div>
          </div>
        ) : null}
        {showCountry ? (
          <div className="row">
            <div className="col-sm-7 col-md-6 col-lg-5">
              <DumbField
                type="text"
                required={required}
                parentType="addressBlock"
                label="Country"
                fieldId={`addr-country-${fieldId}`}
              >
                <Select
                  onChange={this.setFieldValue}
                  onBlur={(value, e) => {
                    this.handleFieldBlur(e)
                  }}
                  options={getCountryOptions()}
                  autoComplete="country"
                  name={isNewFormat ? 'Country' : 'COUNTRY'}
                  value={isNewFormat ? value.Country : value.COUNTRY}
                  required={true}
                  width="100%"
                  validityClass={isValidClass}
                  isValid={this.state.isValid}
                  disabled={disabled === true ? true : disableCountry}
                  fieldId={`addr-country-${fieldId}`}
                  ariaLabel={`${label}: country`}
                />
              </DumbField>
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

export default connect(
  (state, props) => ({
    hasAddresses:
      (getFieldsByType(['addressBlock', 'registeredAgentSearch'], state.wizard.wizard.fields) || [])
        .reduce((ads, ad) => {
          if (ad.type === 'registeredAgentSearch') {
            return [
              ...ads,
              { ...ad, fieldId: ad.fieldId + '_PRIMARY', value: { ADDR1: ad.value.ADDR1 } },
              { ...ad, fieldId: ad.fieldId + '_MAIL', value: { ADDR1: ad.value.MAIL_ADDR.ADDR1 } },
            ]
          } else {
            return [...ads, ad]
          }
        }, [])
        .filter(
          (address) =>
            address.parent.type !== 'REPEATER' &&
            address.fieldId !== props.fieldId &&
            address.value.ADDR1 !== '' &&
            address.value.ADDR1 !== null &&
            address.active
        )
        .filter((address) => getControlIsRenderable(address, state.wizard.wizard.fields)).length >
      0,
  }),
  { setFieldAttributes }
)(AddressBlock)
